import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { P, match } from 'ts-pattern';
import type { ApiResponseBody, ApiSearchQuery } from '@/lib/api/api-type-helper';
import { defaultNS, useTranslation } from '@/lib/i18n';
type PlaceQuery = ApiSearchQuery<'/v2/places', 'get'>;
type Place = ApiResponseBody<'/v2/places/{placeId}', 'get'>;
export const PlaceCategory = {
  ALL: 'ALL',
  PLANNED: 'PLANNED',
  ACTIVE: 'ACTIVE',
  TEMPORARILY_CLOSED: 'TEMPORARILY_CLOSED',
  CLOSED: 'CLOSED'
} as const satisfies Record<NonNullable<PlaceQuery['category']>, string>;
export type PlaceCategory = EnumUnion<typeof PlaceCategory>;
export const PlaceStatus = {
  PLANNED: 'PLANNED',
  ACTIVE: 'ACTIVE',
  TEMPORARILY_CLOSED: 'TEMPORARILY_CLOSED',
  CLOSED: 'CLOSED',
  UNDER_CONSTRUCTION: 'UNDER_CONSTRUCTION',
  UNDER_RENOVATION: 'UNDER_RENOVATION',
  PLANNED_CLOSURE: 'PLANNED_CLOSURE',
  SUSPENDED: 'SUSPENDED'
} as const satisfies Record<NonNullable<Place['status']>, string>;
export type PlaceStatus = EnumUnion<typeof PlaceStatus>;
export function usePlaceStatusSelectOptions() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.places.shared.status'
  });
  return Object.values(PlaceStatus).map(status => ({
    value: status,
    label: t(status)
  }));
}
export const AreaUnit = {
  M2: 'M2',
  KM2: 'KM2',
  HA: 'HA'
} as const satisfies Record<NonNullable<Place['attribute']['totalAreaUnit']>, string>;
export type AreaUnit = EnumUnion<typeof AreaUnit>;
export function toAreaUnitLabel(unit?: AreaUnit) {
  return match(unit).with(AreaUnit.M2, () => 'm2').with(AreaUnit.KM2, () => 'km2').with(AreaUnit.HA, () => 'ha').with(P.nullish, () => '').exhaustive();
}
type PlaceAdministratorQuery = ApiSearchQuery<'/v2/places/{placeId}/administrators', 'get'>;
export const PlaceAdministratorCategory = {
  ALL: 'ALL',
  PRIMARY: 'PRIMARY'
} as const satisfies Record<NonNullable<PlaceAdministratorQuery['category']>, string>;
export type PlaceAdministratorCategory = EnumUnion<typeof PlaceAdministratorCategory>;